import React, { FunctionComponent } from 'react'

import { useTranslation } from 'react-i18next'
import { SpaceProps } from 'styled-system'

import { Button, ButtonVariant } from '@/atoms/button'
import { Box, Flex } from '@/atoms/layout'
import { ErrorMessage } from '@/components/form-elements'
import { Space } from '@/styles'

interface Props {
  submitTitle?: string
  closeTitle?: string
  submitting?: boolean
  onClose?: () => void
  submitDisabled?: boolean
  error?: string
  hideCloseButton?: boolean
  hideSubmitButton?: boolean
  onSubmit?: () => void
}

const SubmitButtons: FunctionComponent<Props & SpaceProps> = ({
  onClose,
  submitTitle,
  closeTitle,
  submitting,
  submitDisabled,
  error,
  hideCloseButton = false,
  hideSubmitButton = false,
  onSubmit,
  ...spaceProps
}) => {
  const { t } = useTranslation()
  const handleClose = (): void => {
    onClose && onClose()
  }
  const handleSubmit = (): void => {
    onSubmit && onSubmit()
  }

  return (
    <Box {...spaceProps}>
      {error && <ErrorMessage display="block" error={error} mb={Space.S12} ml={Space.S12} />}
      <Flex alignItems="center" height={36}>
        {!hideCloseButton && (
          <Button type="button" variant={ButtonVariant.LIGHT} onClick={handleClose}>
            {closeTitle ?? t('global.close_btn')}
          </Button>
        )}

        {!hideSubmitButton && (
          <Box ml={Space.S12}>
            <Button
              disabled={submitDisabled || !!error || submitting}
              loading={submitting}
              type={onSubmit ? 'button' : 'submit'}
              onClick={handleSubmit}
            >
              {submitTitle ?? t('global.confirm_btn')}
            </Button>
          </Box>
        )}
      </Flex>
    </Box>
  )
}

export default SubmitButtons
